import { eventBus } from '@/main'
import getPathToRedirectLoggedInUser from '@/mixins/getPathToRedirectLoggedInUser'
import store from '@/store'

const translate = (key, plural = false) =>
  store.getters.translation(key, plural)

const verifyEmail = async (token: string) => {
  try {
    await store.dispatch('user/verifyEmailAddress', token)

    eventBus.$emit(
      'showSnackbarMessage',
      translate('SNACKBAR_EMAIL_VERIFICATION_STATUS_VERIFIED'),
    )
  } catch (e) {
    eventBus.$emit(
      'showSnackbarMessage',
      translate('SNACKBAR_EMAIL_VERIFICATION_STATUS_INVALID'),
      { color: 'error' },
    )
  }
}

export default async (to, from, next) => {
  const { token } = to.params

  await verifyEmail(token)

  if (!store.getters['auth/isAuthenticated']()) {
    next('/login')
    return
  }

  try {
    next(await getPathToRedirectLoggedInUser())
  } catch (error) {
    next('/login')
  }
}
